<template>
  <vs-popup
    id="report-history-dialog"
    class="pr-32 pl-32"
    :active.sync="showDialog"
    title="変更履歴"
    :fullscreen="true"
  >
    <div class="scroll-area">
      <vs-list>
        <vs-list-header
          v-if="groupedHistories.today.length !== 0"
          title="今日"
        ></vs-list-header>
        <vs-list-item
          v-for="today in groupedHistories.today"
          :key="today.id"
          icon="schedule"
          :title="today.msg"
          :subtitle="today.cmt"
          ><span class="p-2 aisea-text-14-400-dark-gray">{{
            today.time
          }}</span></vs-list-item
        >
        <vs-list-header
          v-if="groupedHistories.yesterday.length !== 0"
          title="昨日"
        ></vs-list-header>
        <vs-list-item
          v-for="yesterday in groupedHistories.yesterday"
          :key="yesterday.id"
          icon="schedule"
          :title="yesterday.msg"
          :subtitle="yesterday.cmt"
          ><span class="aisea-text-14-400-dark-gray">{{
            yesterday.time
          }}</span></vs-list-item
        >
        <vs-list-header
          v-if="groupedHistories.more.length !== 0"
          title="さらに前"
        ></vs-list-header>
        <vs-list-item
          v-for="more in groupedHistories.more"
          :key="more.id"
          icon="schedule"
          :title="more.msg"
          :subtitle="more.cmt"
          ><span class="aisea-text-14-400-dark-gray">{{
            more.time
          }}</span></vs-list-item
        >
      </vs-list>
    </div>
  </vs-popup>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vesselNoonReportDetail");

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    groupedHistories: { type: Object, required: true },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapState(["histories"]),
  },
  methods: {
    show() {
      this.showDialog = true;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#report-history-dialog {
  --vs-primary: $aisea-gray;

  .scroll-area {
    overflow-y: auto;

    .vs-list--subtitle {
      word-break: break-all;
    }
  }
}
</style>
